module.exports = __webpack_public_path__ + "img/PR10.b6ad8a02.png";